import {NgModule} from '@angular/core';
import {
    ApparatusCardRepairFormArrayComponent
} from './components/apparatus-card-repair-form-array/apparatus-card-repair-form-array.component';
import {SharedModule} from '@helpers/modules/shared.module';
import {ApparatusCardRepairSubformComponent} from './components/apparatus-card-repair-subform/apparatus-card-repair-subform.component';
import {FilesUploaderModule} from '@components/files-uploader/files-uploader.module';
import {IconsModule} from '@lab365/icons';

@NgModule({
    imports: [
        SharedModule,
        FilesUploaderModule,
        IconsModule,
    ],
    exports: [
        ApparatusCardRepairFormArrayComponent,
    ],
    declarations: [
        ApparatusCardRepairFormArrayComponent,
        ApparatusCardRepairSubformComponent,
    ],
    providers: [],
})
export class ApparatusCardRepairsModule {

}
